import React from "react";
import useLayout from "~/hooks/useLayout";
import useMount from "~/hooks/useMount";
import { EnvelopeSimple } from "phosphor-react";
import { CONTACT_EMAIL } from "~/utils/Constants";

export default function ContactPage() {
  const { setLayout } = useLayout();

  useMount(() => {
    setLayout({
      title: "Contact",
      activeMenuKeys: ["contact"],
    });
  });

  const handleContactClick = () => {
    window.location.href = `mailto:${CONTACT_EMAIL}`;
  };

  return (
    <div className="flex flex-col items-center justify-center mt-10 mb-10 px-4">
      <h2 className="font-bold text-2xl mb-1">
        Pour nous contacter, envoyez-nous un{" "}
        <span className="text-primary">email</span>{" "}
      </h2>
      <p className="mb-8">Nous vous répondrons dans les plus brefs délais.</p>
      <div
        className="shadow-xl py-6 px-10 m-10 flex flex-col justify-center items-center cursor-pointer border-2 rounded w-72"
        onClick={handleContactClick}
      >
        <EnvelopeSimple size={55} />
        <div className="bg-primary py-1 px-2 rounded-xl mt-2">
          <p className="text-white">{CONTACT_EMAIL}</p>
        </div>
      </div>
    </div>
  );
}
